import { useQuery } from 'react-query';
import useAbortController from 'hooks/useAbortController';
import { getPrimaryFormData } from 'services/formService';
import { useContext } from 'react';
import { AppContext } from 'contexts/AppContext';
import QUERY_KEYS from 'constants/queryKeys';
import { UserContext } from 'contexts/UserContext';

const usePrimaryFormDataQuery = ({ options } = {}) => {
  const abortControllerOptions = useAbortController();
  const { organizationId, propertyId } = useContext(AppContext);
  const {
    userProfile: { applicantId, isPrimaryProspect },
  } = useContext(UserContext);
  const queryKey = QUERY_KEYS.primaryFormData({ organizationId, propertyId });

  return useQuery(
    queryKey,
    async () => {
      const response = await getPrimaryFormData({
        organizationId,
        propertyId,
        applicantId,
        options: abortControllerOptions,
      });

      return { applicantId, ...response };
    },
    {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      refetchInterval: false,
      refetchOnSettled: false,
      retry: false,
      enabled: Boolean(
        organizationId?.length &&
          propertyId?.length &&
          applicantId?.length &&
          isPrimaryProspect,
      ),
      ...options,
    },
  );
};

export default usePrimaryFormDataQuery;
